import React from 'react';

import { Modal, message } from 'antd';

import fetch from '../../fetch';
import utils from '../../../utils';


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
 const searchProjectByPersonId = (keywords = { pageNum: 1, pageSize: 100 }) => {
    return fetch.post('ky/project/searchProjectByPersonId', keywords)
        .then(response => response.payload.data)
}

export default {
    searchProjectByPersonId
}